import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useDispatch, useSelector } from 'hooks';
import LanguageEnum from 'types/LanguageEnum';
import actions from 'modules/translations/actions';
import { getAllLanguages } from 'modules/translations/selectors/language';
import { getSelectedLanguage } from 'modules/translations/selectors';

import Modal from '../Modal';
import RadioBullet from '../RadioBullet';
import Flag from './components/Flags';

interface LanguageSelectModalProps {
  open: boolean;
  onClose: () => void;
}

const LanguageSelectModal: React.FC<LanguageSelectModalProps> = ({ open, onClose }) => {
  const ref = React.useRef<HTMLButtonElement>(null);
  const dispatch = useDispatch();

  const locale = useSelector(getSelectedLanguage);
  const languages = useSelector(getAllLanguages);

  const handleSelect = React.useCallback((language: LanguageEnum) => {
    if (language !== locale) {
      dispatch(actions.setSelectedLanguage(language));
      onClose();
    }
  }, [dispatch, locale, onClose]);

  return (
    <Modal
      open={open}
      focusRef={ref}
      className="modal-large max-h-[75vh] min-h-[300px] kioskPartteam:min-h-[600px] kioskSharebox:min-h-[400px] flex flex-col"
      title={<FormattedMessage id="helpLine.changeLanguage" defaultMessage="Change language" tagName="h2" />}
      onClose={onClose}
    >
      <div className="scroll-smooth flex-1 min-h-0 overflow-y-auto p-1">
        <div className="flex flex-col items-center" data-testid="languageSelectModal">
          {languages.map((language) => (
            <RadioBullet
              key={language}
              value={language}
              checked={locale === language}
              onChange={(value) => handleSelect(value)}
              title={(
                <>
                  <Flag locale={language} className="inline-block align-middle w-6 h-6 mr-2" />
                  <FormattedMessage id={`language.${language}`} defaultMessage={language.toUpperCase()} />
                </>
              )}
              description={null}
            />
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default LanguageSelectModal;
